<div class="bg-white rounded-lg border max-w-xl">

    <div class="px-5 py-2 flex items-center">
        <span class="cursor-grab w-full flex items-center" cdkDragHandle><i class="ri-draggable"></i> <span
                class="text-xs font-semibold">Badge Form</span></span>
        <span class="divider divider-horizontal"></span>
        <span class="flex gap-3">

            @if (flag == 1) {
            @if (!isPreview) {
            <button class="btn btn-sm btn-circle bg-white text-green-600" [disabled]="coursePublished && flag !== 1 || isSubmitting"
                (click)="!(coursePublished && flag !== 1) && !isSubmitting && addBadgeStructure()">
                @if (isSubmitting) {<i class="ri-loader-4-line animate-spin"></i>}@else{<i class="ri-check-line"></i>}
              </button>
            <button class="btn btn-sm btn-circle bg-white text-red-600" [disabled]="coursePublished && flag !== 1 || isSubmitting"
                (click)="!(coursePublished && flag !== 1) && !isSubmitting && deleteBadgeStructureNew()"><i class="ri-delete-bin-7-line"></i></button>
            }
            }@else{

            @if (isPreview) {
            <button *ngIf="isPreview" class="btn btn-sm btn-circle bg-white text-zinc-600"
[disabled]="coursePublished && flag !== 1"
                (click)="!(coursePublished && flag !== 1) && (isPreview = false)"><i class="ri-pencil-fill"></i></button>
            <button class="btn btn-sm btn-circle bg-white text-red-600" [disabled]="coursePublished && flag !== 1 || isSubmitting"
                (click)="!(coursePublished && flag !== 1) && !isSubmitting && deleteBadgeStructure(badgeData?.id)"><i class="ri-delete-bin-7-line"></i></button>
            }@else{
            <button class="btn btn-sm btn-circle bg-white text-zinc-600" [disabled]="coursePublished && flag !== 1"
                (click)="!(coursePublished && flag !== 1) && closePreview()"><i class="ri-close-line"></i></button>
            <button class="btn btn-sm btn-circle bg-white text-green-600" [disabled]="coursePublished && flag !== 1 || isSubmitting"
                (click)="!(coursePublished && flag !== 1) && !isSubmitting && UpdateBadgeStructure()">
                @if (isSubmitting) {<i class="ri-loader-4-line animate-spin"></i>}@else{<i class="ri-check-line"></i>}
              </button>
            }
            }

        </span>
    </div>
    <hr>
    @if (isPreview) {
    <!-- preview -->
    <div class="p-5">
        <div class="w-full bg-white flex items-center gap-5 h-[7rem]">

            <!-- Image -->
            <div class="w-[8rem] h-full shrink-0">
                <img
                    class="h-full w-full object-cover rounded-md"
                    src="assets/badge_icon.png"
                    alt="Badge">
            </div>

            <!-- Details -->
            <ul class="w-full capitalize space-y-2 overflow-hidden">

                <li class="flex items-center gap-2">
                    <span class="uppercase text-xs text-zinc-500 shrink-0">
                        Badge ID :
                    </span>

                    <span
                        class="font-medium text-sm truncate max-w-[200px]"
                        [title]="badgeData?.badge_id">

                        {{ badgeData?.badge_id || 'N/A' }}

                    </span>
                </li>

                <li class="flex items-center gap-2">
                    <span class="uppercase text-xs text-zinc-500 shrink-0">
                        Activities :
                    </span>

                    <span class="font-medium text-sm">
                        {{ badgeData?.activities_to_be_considered || 'N/A' }}
                    </span>
                </li>

            </ul>
        </div>
    </div>
    <!-- preview -->
    }@else {
    <!-- form -->
    <div class="p-5">
        <form [formGroup]="badgeForm">
            <div class="grid grid-cols-2 gap-5">

                <div class="col-span-2">
                    <label class="form-control w-full">
                        <div class="label">
                            <span class="label-text text-sm font-semibold">Select Badge</span>
                        </div>
                        <select formControlName="badge_id" class="select select-sm select-bordered w-full"
                            [ngClass]="{ 'error': badgeForm.get('badge_id')?.touched && badgeForm.get('badge_id')?.hasError('required') }">
                            <option value="" disabled selected>Select Badge</option>
                            <option value="1">Badge 1</option>
                            <option value="2">Badge 2</option>
                            <option value="3">Badge 3</option>
                        </select>
                        @if (badgeForm.get('badge_id')?.touched &&
                        badgeForm.get('badge_id')?.hasError('required')){
                        <span class="text-xs text-red-500">Please select a badge</span>
                        }
                    </label>
                </div>

                <!-- <div class="col-span-2">
                    <label class="form-control w-full">
                        <div class="label">
                            <span class="label-text text-sm font-semibold">Activities to be Considered</span>
                        </div>
                        <textarea formControlName="activities_to_be_considered" placeholder="Enter activities to be considered for this badge"
                            class="textarea textarea-bordered w-full"
                            [ngClass]="{ 'error': badgeForm.get('activities_to_be_considered')?.touched && badgeForm.get('activities_to_be_considered')?.hasError('required') }"></textarea>
                        @if (badgeForm.get('activities_to_be_considered')?.touched &&
                        badgeForm.get('activities_to_be_considered')?.hasError('required')){
                        <span class="text-xs text-red-500">Activities are required</span>
                        }
                    </label>
                </div> -->

            </div>
        </form>
    </div>
    <!-- form -->
    }

</div>